import React, { useCallback, useContext, useEffect, useState } from 'react';

import { useLocalized } from 'utils/useLocalized';

import Badge from '@components/badge';
import Icon from '@components/icon';

import CarIcon from './CarIcon';

import styles from './styles.modules.scss';
import i18nStrings from './strings';
import { urlParams } from 'logic/entities';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { PeriodType } from 'consts/consts';
import { DataContext } from 'contexts';
import Interpolate from '@doist/react-interpolate';
import interpolate from 'ati-utils/interpolate';

const bannerKey = 'HideMonthlyPayBanner';

const MonthlyPaymentBanner = () => {
    const strings = useLocalized(i18nStrings);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const {processPay, licenseInfo} = useContext(DataContext);
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        setShowBanner((!localStorage.getItem(bannerKey) && !!licenseInfo.searchAccessPrices) ?? false);
    }, [licenseInfo.searchAccessPrices]);

    const navigateToPayPage = useCallback(() => {
        searchParams.set(urlParams.payPeriod, String(PeriodType.month));
        processPay(navigate, searchParams.toString(), PeriodType.month);
    }, [processPay, navigate, searchParams]);

    const handleCloseBanner = useCallback((e) => {
        setShowBanner(false);
        localStorage.setItem(bannerKey, false);
        e.stopPropagation();
    }, []);

    return showBanner && (
        <div
            className={styles['banner']}
            onClick={navigateToPayPage}
        >
	        <div className={styles['icon']}>
		        <CarIcon />
	        </div>
            <div className={styles['header-description']}>
                <div className={styles['header']}>
                    <b>
                        {strings.header}
                    </b>
                    <Badge size="small">
                        {'NEW'}
                    </Badge>
                </div>
                <div className={styles['description']}>
                    {strings.description}
                </div>
            </div>
            <div className={styles['trapezoid-small']} />
            <div className={styles['trapezoid']}>
                <div className={styles['profit-text']}>
	                <Interpolate
                        mapping={{
                            p:  <div className={styles['percent']}/>
                        }}
                        string={interpolate(strings.profit, {percent: 73})}
	                />
                </div>
                <div
                    className={styles['close-icon']}
                    onClick={handleCloseBanner}
                >
                    <Icon
                        color="white"
                        name="ic_close"
                        size="s"
                    />
                </div>
            </div>
        </div>
    );
};

export default MonthlyPaymentBanner;
